import React from "react";

import { Alerta, Box, CampoEstatico, TipoAlerta, Row, Col, TipoCampoEstatico } from "@intechprev/componentes-web";

import { EmprestimoService } from "../../services";
import { PrestacaoEntidade, ContratoEntidade } from "../../entidades";

import { MasterPage, NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

interface Props {
  match?: any;
}

interface State {
  numero: string;
  ano: string;
  detalhes: ContratoEntidade;
  prestacoes: Array<PrestacaoEntidade>;
}

export class EmprestimoDetalhe extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("emprestimo_detalhe");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      numero: props.match.params.numero,
      ano: props.match.params.ano,
      detalhes: null,
      prestacoes: []
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      const detalhes = await EmprestimoService.BuscarDetalhePorNumeroAno(this.state.numero, this.state.ano);

      await this.setState({ detalhes });

      await this.page.current.alternarLoading();
    } catch (err) {
      console.log(err);
    }
  };

  condicaoRenderEmprestimo = () => {
    return this.state.detalhes;
  };

  renderDadosEmprestimo = () => {
    const nome: string = this.state.detalhes.NOME_PENSIONISTA ? this.state.detalhes.NOME_PENSIONISTA : this.state.detalhes.NOME_PARTICIPANTE;
    const cpf: string = this.state.detalhes.CPF_PENSIONISTA ? this.state.detalhes.CPF_PENSIONISTA : this.state.detalhes.CPF_PARTICIPANTE;

    return (
      <Box titulo={"Dados do Empréstimo"}>
        <CampoEstatico valor={`${this.state.detalhes.NUM_CONTRATO}/${this.state.detalhes.ANO_CONTRATO}`} titulo={"Contrato"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={nome} titulo={"Nome"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={cpf} titulo={"CPF"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.DS_PLANO} titulo={"Plano"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.DS_SITUACAO} titulo={"Situação"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.DS_MODAL} titulo={"Modalidade"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.DS_NATUR} titulo={"Natureza"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.PRAZO} titulo={"Prazo"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.DT_SOLICITACAO} titulo={"Solicitado em"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.DT_CREDITO} titulo={"Data de Crédito"} tamanhoTitulo={"5"} />

        <CampoEstatico valor={this.state.detalhes.VL_SOLICITADO} titulo={"Valor Solicitado"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico valor={this.state.detalhes.VL_PRESTACAO} titulo={"Valor Prestação"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico valor={this.state.detalhes.VL_IOF} titulo={"IOF"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico valor={this.state.detalhes.VL_TX_ADM} titulo={"Taxa ADM"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico valor={this.state.detalhes.VL_TX_INAD} titulo={"Taxa Garantia"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico valor={this.state.detalhes.VL_REFORMADO} titulo={"Valor Reformado"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico valor={this.state.detalhes.VL_LIQUIDO} titulo={"Valor Líquido"} tamanhoTitulo={"5"} tipo={TipoCampoEstatico.dinheiro} />

        <CampoEstatico
          valor={`${this.state.detalhes.NUM_BANCO}/${this.state.detalhes.NUM_AGENCIA}/${this.state.detalhes.NUM_CONTA}`}
          titulo={"Dados Bancários"}
          tamanhoTitulo={"5"}
        />

        {this.state.detalhes.CD_SITUACAO === 0 && (
          <Alerta
            tipo={TipoAlerta.info}
            mensagem={
              "Para cancelar o empréstimo, é necessário solicitar por e-mail <b>seguridade@previrb.com.br</b>, colocando no assunto Cancelamento do Empréstimo e o número da sua matrícula, até o dia 20 do mês do crédito do empréstimo."
            }
          />
        )}
      </Box>
    );
  };

  renderDadosPrestacoes = () => {
    return (
      <Box titulo={"Prestações"}>
        <table className={"table table-striped table-sm"}>
          <thead>
            <tr>
              <th>Nº</th>
              <th>Vencimento</th>
              <th>Pagamento</th>
              <th>Prestação</th>
              <th>Recebido</th>
              <th>Saldo Devedor</th>
            </tr>
          </thead>
          <tbody>
            {this.state.detalhes.Prestacoes.map((prestacao: any, index: number) => {
              if (prestacao.TIPO === "P") {
                return (
                  <tr key={index}>
                    <td>{prestacao.PARCELA}</td>
                    <td>{prestacao.DT_VENC}</td>
                    <td>{prestacao.DT_PAGTO}</td>
                    <td>
                      <CampoEstatico valor={prestacao.VL_PRESTACAO} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                    <td>
                      <CampoEstatico valor={prestacao.VL_RECEBIDO} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                    <td>
                      <CampoEstatico valor={prestacao.VL_SALDO_ATUAL} tipo={TipoCampoEstatico.dinheiro} />
                    </td>
                  </tr>
                );
              } else if (prestacao.TIPO === "S") {
                return (
                  <tr key={index}>
                    <td></td>
                    <td>{prestacao.DT_VENC}</td>
                    <td colSpan={4}>Suspensa</td>
                  </tr>
                );
              } else {
                return (
                  <tr key={index}>
                    <td colSpan={6}></td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </Box>
    );
  };

  renderComEmprestimo = () => {
    return (
      <>
        <Row>
          <Col tamanho={"12"} className={"col-lg-6"}>
            {this.renderDadosEmprestimo()}
          </Col>

          <Col tamanho={"12"} className={"col-lg-6"}>
            {this.renderDadosPrestacoes()}
          </Col>
        </Row>
      </>
    );
  };

  renderSemEmprestimo = () => {
    return <Alerta mensagem={"Houve um erro ao carregar o detalhamento do empréstimo. Tente novamente mais tarde."} tipo={TipoAlerta.danger} />;
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONSULTA} {...this.props} ref={this.page}>
        {this.condicaoRenderEmprestimo() ? this.renderComEmprestimo() : this.renderSemEmprestimo()}
      </MasterPage>
    );
  };
}
